export interface IChangedValue {
  op: string;
  path: string;
  value?: any;
}

export const formatValuesForUpdate = <T extends Record<string, unknown>>(values: T): IChangedValue[] => {
  return Object.entries(values).reduce((acc: IChangedValue[], [ key, value ]) => {
    if (value === null) {
      acc.push({
        op: "remove",
        path: `/${ key }`,
      });
    } else {
      acc.push({
        op: "replace",
        path: `/${ key }`,
        value: value,
      });
    }
    return acc;
  }, []);
};
